import {
  TextAlignment,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';
import React from 'react';
import { CarHeaderContainer } from './styled';

export interface CarHeaderProps {
  model: string;
}

export const CarHeader: React.FC<CarHeaderProps> = (props) => {
  const { model } = props;

  return (
    <CarHeaderContainer>
      <TextCustom
        appearance={TextAppearance.headline300}
        style={{
          fontSize: TextSize.TextSize28,
          lineHeight: TextLineHeight.TextLineHeight32,
          textAlign: TextAlignment.center,
        }}
      >
        Results for your
      </TextCustom>
      <TextCustom
        appearance={TextAppearance.headline300}
        style={{
          fontSize: TextSize.TextSize28,
          lineHeight: TextLineHeight.TextLineHeight32,
          textAlign: TextAlignment.center,
          fontWeight: TextWeight.bold,
        }}
      >
        {model}
      </TextCustom>
    </CarHeaderContainer>
  );
};
